<template>
  <div v-if="success" class="success">
    <h1>{{ __('Lyckades!') }}</h1>
    <p class="margin-bottom-x2">{{ __('Din abonnemang har ändrats') }}.</p>
    <button class="button" @click="() => this.$router.push('/')">
      {{ __('Tillbaka') }}
    </button>
  </div>
  <div v-else-if="step === 1">
    <h1>{{ __('Ändra plan') }}</h1>
    <choose-product
      :preselected="currentProductId"
      v-model="newProductId"
      :next="() => step++"
    >
      <div class="row">
        <button @click="() => $router.go(-1)" class="button button-snd">
          {{ __('Tillbaka') }}
        </button>
        <button
          @click="step = 2"
          class="button desktop"
          :disabled="
            (!newProductId && newProductId !== 0) ||
              newProductId === currentProductId
          "
        >
          {{ __('Fortsätt') }}
        </button>
      </div>
    </choose-product>
  </div>
  <div v-else-if="step === 2">
    <h1>{{ __('Att betala') }}</h1>
    <div class="card card-confirm-change margin-bottom-x2">
      <span class="title-price"> {{ remainingPayment }} {{ __('SEK') }} </span>
      <span class="text-small margin-bottom-x2">
        {{ `${__('För återstående')} ${remainingMonths} ${__('månader')}` }}
      </span>
      <h3>{{ __('Orderdetaljer') }}</h3>
      <p>
        {{ __('Månadsplan') }}:
        {{
          `${currentSubscription} ${__('månad')}${
            currentSubscription > 1 ? __('er') : ''
          }`
        }}
      </p>
      <p>{{ __('Abonnemang') }}: {{ __(newProduct.name) }}</p>
      <p class="margin-bottom-x2">
        {{ __('Månadskostnad') }}:
        {{ Math.round(newProduct.prices[currentSubscriptionId] / currentSubscription) }} {{ __('SEK') }}
      </p>
      <div>
        <div
          class="details text-small"
          :style="[
            {
              'max-height': showDetails ? '550px' : '0',
              transition: 'max-height 1s',
              overflow: 'hidden',
            },
          ]"
        >
          <p>{{ __('Vi har räknat') }}:</p>
          <p class="text-white margin-bottom-x2">
            {{
              `${remainingMonths} ${__('mån')}*${this.newPrice} ${__(
                'SEK'
              )} - ${remainingMonths} ${__('mån')}*${this.currentPrice} ${__(
                'SEK'
              )} = ${remainingPayment} SEK`
            }}
          </p>
          <p class="text-xs-small">
            {{
              `${__('Månadsplan')}: ${currentSubscription} ${__('mån')}`
            }}
          </p>
          <p class="text-xs-small margin-bottom-x2">
            {{ `${__('Återstående tid')}: ${remainingMonths} ${__('mån')}` }}
          </p>
          <p class="text-xs-small">
            {{
              `${__('Betalat belopp')}: ${(currentSubscription -
                remainingMonths) *
                currentPrice} ${__('SEK')}`
            }}
          </p>
          <p class="text-xs-small">
            {{
              `${__('Kvarstående belopp')}: ${remainingMonths *
                currentPrice} ${__('SEK')}`
            }}
          </p>
          <p class="text-xs-small margin-bottom-x1">
            {{
              `${__('Nytt abonnemangs pris')}: ${remainingMonths *
                currentPrice +
                remainingPayment} ${__('SEK')}`
            }}
          </p>
        </div>
        <icon-chevron-down class="text-white" :rotate="showDetails"  @click.native="showDetails = !showDetails"/>
      </div>
    </div>
    <div class="row">
      <button @click="step = 1" class="button button-snd">
        {{ __('Tillbaka') }}
      </button>
      <button @click="step = 3" class="button desktop">
        {{ __('Fortsätt') }}
      </button>
    </div>
  </div>
  <div v-else-if="step === 3">
    <h1>{{ __('Ange betalningsinfo') }}</h1>
    <payment :next="() => this.updateProduct()">
      <div class="fix-width text-small margin-bottom-x3">
        {{
          __(
            'Välj någon av ovan alternativ för att gå vidare. Medlemskapet börjar så fort du har angett din betalningsinformation'
          )
        }}.
      </div>
    </payment>
  </div>
</template>
<script>
export default {
  data () {
    return {
      success: false,
      step: 1,
      newProductId: null,
      showDetails: false,
    }
  },
  methods: {
    updateProduct () {
      this.$store.commit('setProductId', this.newProductId)
      this.success = true
    },
  },
  computed: {
    availableProducts () {
      return this.$store.getters.availableProducts
    },
    currentProductId () {
      return this.$store.getters.currentProductId
    },
    currentSubscription () {
      return this.$store.getters.currentSubscription
    },
    currentSubscriptionId () {
      return this.$store.getters.currentSubscriptionId
    },
    currentProduct () {
      return this.$store.getters.currentProduct
    },
    remainingMonths () {
      return Math.max(this.currentSubscription - 1, 1) // TODO (get remaining months from db, NOW ONLY SUBTRACTING 1 FROM TOTAL)
    },
    newProduct () {
      if (this.newProductId === -1) return
      return this.availableProducts[this.newProductId]
    },
    remainingPayment () {
      if (!this.newProduct) return
      return (
        this.newPrice * this.remainingMonths -
        this.currentPrice * this.remainingMonths
      )
    },
    newPrice () {
      return Math.round(this.newProduct.prices[this.currentSubscriptionId] / this.currentSubscription)
    },
    currentPrice () {
      return Math.round(this.currentProduct.prices[this.currentSubscriptionId] / this.currentSubscription)
    },
  },
  components: {
    ChooseProduct: () => import('@/components/ChooseProduct.vue'),
    Payment: () => import('@/components/Payment.vue'),
    IconChevronDown: () => import('../../components/icons/IconChevronDown.vue'),
  },
}
</script>
<style lang="less">
@import '../../style/variables.less';

.card-confirm-change {
  background: #1c1c1c;
  padding: 30px 20px;
  max-width: 80vw;
  width: 400px;
  .title-price {
    color: @color-orange;
    font-size: 3rem;
    font-family: Oswald;
    font-weight: 500;
    margin-bottom: -0.3rem;
  }
  .details {
    line-height: 2em;
    .text-xs-small {
      line-height: 1.5em;
    }
  }
}
</style>
